module.exports = __webpack_public_path__ + "media/photo/AdobeStock_291615382@2x-bf06c063.png";